import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'
import { LogRequest } from '../../../protos/generated/admin.pb';

@Injectable({
  providedIn: 'root'
})
export class FilterStateService {
  private filterStateSubject = new BehaviorSubject<LogRequest>(new LogRequest());
  filterState$ = this.filterStateSubject.asObservable();

  setFilterState(filterState: LogRequest) {
    this.filterStateSubject.next(filterState);
  }


  getFilterState(): LogRequest {
    return this.filterStateSubject.getValue();
  }
  getFilterQueryParams(): any {
    const filter = this.getFilterState();
    return {
      severity: filter.severity,
      sourceContext: filter.sourceContext,
      method: filter.method,
      filter: filter.filter,
      id: filter.id,
      startTime: filter.startTime?.seconds,
      endTime: filter.endTime?.seconds
    };
  }
  
}
